import { Button, Container, Grid, GridColumn, Heading, Notice, Separator, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import { EMAIL_SINGLE_PANEL_PATH } from '../Routes';
import { ProfileMapper } from '../stores/BaseLoginStore';
import { MERGE_ENDPOINT } from '../stores/MergeStore';
import useStores from '../stores/UseStores';
import ErrorUtil from '../util/ErrorUtil';

const AccountMerge = observer((): React.JSX.Element => {
  const {
    routeStore,
    mergeStore,
    accountInfoStore,
    translateStore: { translate },
  } = useStores();
  const { resolvedMergeParams: mergeParams, submitting, calledMergeEndpoint } = mergeStore;

  React.useEffect(() => {
    if (!mergeParams?.mergeStage) {
      routeStore.route(routeStore.homePageWithParams);
    }
  });

  if (!mergeParams.mergeStage) {
    ErrorUtil.pushErrorToTeliaRumAndLogWithLocation('mergeParams.headerText has no value');
  }

  if (mergeStore.canMergeAccounts()) {
    return (
      <Container>
        <Text className={'text-center'}>
          <Notice direction="vertical">
            <Heading level={1} className="h3 text-center" id="join-accounts-modal-title">
              {translate('MergeConfirm.title')}
            </Heading>
          </Notice>
          <p>
            {translate('MergeConfirm.p', {
              account1: accountInfoStore.accountName,
              account2: mergeStore.resolvedMergeParams.mergeAccount,
            })}
          </p>
          <Separator spacing={'small'} color={'invisible'} />
          <Grid align={['center-sm']}>
            <GridColumn width={['xs-6', 'md-4', 'lg-4']}>
              <Button
                isLoading={submitting && calledMergeEndpoint === MERGE_ENDPOINT.CANCEL}
                disabled={submitting && calledMergeEndpoint !== MERGE_ENDPOINT.CANCEL}
                text={translate('merge_accounts.cancel_merge_button_label')}
                onClick={() => mergeStore.handleLogin(MERGE_ENDPOINT.CANCEL)}
              />
            </GridColumn>
            <GridColumn width={['xs-6', 'md-4', 'lg-4']}>
              <Button
                variant={'secondary'}
                isLoading={submitting && calledMergeEndpoint === MERGE_ENDPOINT.MERGE}
                disabled={submitting && calledMergeEndpoint !== MERGE_ENDPOINT.MERGE}
                text={translate('merge_accounts.merge_button_label')}
                onClick={() => mergeStore.handleLogin(MERGE_ENDPOINT.MERGE)}
              />
            </GridColumn>
          </Grid>
        </Text>
      </Container>
    );
  } else if (mergeParams?.mergeStage === ProfileMapper.MERGE_TARGET_IDENTIFIED) {
    return (
      <Container>
        <Notice align={'center'}>
          <span dangerouslySetInnerHTML={{ __html: mergeParams.headerText as string }} />
        </Notice>
        <Separator spacing={'small'} color={'invisible'} />
        <Grid align={['center-sm']}>
          <Button
            onClick={routeStore.navigate}
            url={`${EMAIL_SINGLE_PANEL_PATH}${routeStore.formForwardParamsAnd({ service: 'addEmail', ForceAuth: 'true' })}`}
            isLoading={submitting}
            text={translate('ok_button_label')}
          />
        </Grid>
      </Container>
    );
  } else {
    return (
      <Container>
        <Notice type={'success'}>
          <span dangerouslySetInnerHTML={{ __html: mergeParams.headerText as string }} />
        </Notice>
        <Separator spacing={'small'} color={'invisible'} />
        <Grid align={['center-sm']}>
          <Button isLoading={submitting} text={translate('ok_button_label')} onClick={() => mergeStore.handleLogin(MERGE_ENDPOINT.CONTINUE)} />
        </Grid>
      </Container>
    );
  }
});

export default AccountMerge;
